/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState} from "react";
import SafeLink from "components/commons/SafeLink";
import {WealthyEnv} from "helpers";
import SebiInvestorAwareness from "./SebiInvestorAwareness";

const url = WealthyEnv.URL;

const twitterIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-social-media-icons-twitter.svg`;
const whatsappIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-social-media-icons-whatsapp.svg`;
const facebookIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-social-media-icons-facebook.svg`;
const linkedInIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-social-media-icons-linkedIn.svg`;
const instagramIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-social-media-icons-instagram.svg`;
const youtubeIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/youtube-social-icon.svg`;

const playStoreButton = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-play-store-icon.png`;
const appStoreButton = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-landing-page-app-store-icon.png`;

const NewFooter = () => {
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);

  return (
  <footer className="footer">
    <div className="wl-footer">
      <div className="wl-basic-social-container">

        <div className="wl-basic">
          <img
            alt="wealthy logo"
            className="logo"
            src={`${WealthyEnv.HOMEPAGE_CDN_URL}/partners-footer-wealthy-logo.svg`}
            title="logo of buildwealth technologies private limited"
          />
          <p className="logo-text">
            Make better financial decisions and grow your money. Start your
            journey towards a secure tomorrow with Wealthy.
          </p>
        </div>

        <div className="wl-social-container">
          <p id="footer-follow-title">Follow Us</p>
          <div className="wl-social-wrapper">
            <SafeLink href="https://www.linkedin.com/company/wealthy-in/" rel="noopener noreferrer" target="_blank" >
              <img
                alt="linkedIn-icon"
                loading="lazy"
                src={linkedInIcon}
              />
            </SafeLink>
            <SafeLink href="https://www.instagram.com/wealthy_in/" rel="noopener noreferrer" target="_blank" >
              <img
                alt="instagram-icon"
                loading="lazy"
                src={instagramIcon}
              />
            </SafeLink>
            <SafeLink href="https://www.facebook.com/WealthyIN/" rel="noopener noreferrer" target="_blank" >
              <img
                alt="facebook-icon"
                loading="lazy"
                src={facebookIcon}
              />
            </SafeLink>
            <SafeLink href="https://twitter.com/Wealthy_India" rel="noopener noreferrer" target="_blank" >
              <img
                alt="twitter-icon"
                loading="lazy"
                src={twitterIcon}
              />
            </SafeLink>
            <SafeLink href="https://www.youtube.com/channel/UC9l9bEJdh4amzSVExsGsm3g" rel="noopener noreferrer" target="_blank" >
              <img alt="youtube-icon" loading="lazy" src={youtubeIcon} />
            </SafeLink>
          </div>
        </div>
      </div>

      <div className="wl-products" aria-labelledby="footer-learn-title">
        <p id="footer-learn-title">Learn</p>
        <SafeLink href={`${url}/insights`}>Insights</SafeLink>
        <SafeLink href={`${url}/money-order`}>Money Order</SafeLink>
        <SafeLink href={`${url}/stories`}>Stories</SafeLink>
        <SafeLink href={`${url}/big-picture`}>Big Picture</SafeLink>
      </div>
      <div className="wl-products" aria-labelledby="footer-wealthy-title">
        <p id="footer-wealthy-title">Wealthy</p>
        <SafeLink href={`${url}/account-opening-process`} rel="noopener noreferrer" target="_blank">Account Opening Process</SafeLink>
        <SafeLink href={`${url}/become-mutual-fund-distributor`}rel="noopener noreferrer" target="_blank" aria-label="Become a Mutual Fund Distibutor (opens in new tab)">Become a Mutual Fund Distibutor</SafeLink>
        <SafeLink href={`${url}/careers`} rel="noopener noreferrer" target="_blank">Careers</SafeLink>
        <SafeLink href={`${url}/methodology`} rel="noopener noreferrer" target="_blank">Methodology</SafeLink>
        <SafeLink href={`${url}/partner-support`} rel="noopener noreferrer" target="_blank">Partner-support</SafeLink>
        <SafeLink href={`${url}/account-closure`} rel="noopener noreferrer" target="_blank">Account Closure</SafeLink>
        <SafeLink href={`${url}/partner-account-closure`} rel="noopener noreferrer" target="_blank">Partner Account Closure</SafeLink>
        <SafeLink href={`${url}/download-forms`} rel="noopener noreferrer" target="_blank">Download-forms</SafeLink>
        <SafeLink href={`${url}/compliance/list-of-authorised-persons`} rel="noopener noreferrer" target="_blank">Authorised Persons</SafeLink>
      </div>
      <div className="wl-products" aria-labelledby="footer-legal-title">
        <p id="footer-legal-title">Legal</p>
        <SafeLink href={`${url}/faqs`} rel="noopener noreferrer" target="_blank">FAQs</SafeLink>
        <SafeLink href={`${url}/fund-transfer`} rel="noopener noreferrer" target="_blank">Fund Transfer</SafeLink>
        <SafeLink href={`${url}/contact-us`} rel="noopener noreferrer" target="_blank">Contact us (Broking related)</SafeLink>
        <SafeLink href={`${url}/privacy`} rel="noopener noreferrer" target="_blank">Privacy Policy</SafeLink>
        <SafeLink href={`${url}/refund-policy`} rel="noopener noreferrer" target="_blank">Refund Policy</SafeLink>
        <SafeLink href={`${url}/terms-and-conditions`} rel="noopener noreferrer" target="_blank">Terms and Conditions</SafeLink>
      </div>
    </div>
    <div className="wl-marketing">
      <div />
      <div className="download-app">
        <p className="download-app-text">
          Download Wealthy App
        </p>
        <ul className="download-app-list">
          <li className="download-app-item">
            <SafeLink
              className="download-app-link"
              href={WealthyEnv.PLAY_STORE_DOWNLOAD_LINK}
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt="PLAY-STORE-ICON"
                className="download-app-icon"
                loading="lazy"
                src={playStoreButton}
              />
            </SafeLink>
          </li>
          <li className="download-app-item">
            <SafeLink
              className="download-app-link"
              href={WealthyEnv.APP_STORE_DOWNLOAD_LINK}
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                alt="PLAY-STORE-ICON"
                className="download-app-icon"
                loading="lazy"
                src={appStoreButton}
              />
            </SafeLink>

          </li>
        </ul>
      </div>
    </div>
    <div className="footer-disclaimer">
      <button
        type="button"
        className="footer-disclaimer-toggle"
        aria-expanded={isDisclaimerOpen}
        aria-controls="footer-disclaimer-content"
        onClick={() => setIsDisclaimerOpen(open => !open)}
      >
        Disclaimer
        <img
          className="footer-disclaimer-arrow"
          src="https://i.wlycdn.com/wealthy-home-page/dropdown-header-icon.svg"
          alt="arrow icon"
          aria-hidden="true"
        />
      </button>

      <div
        id="footer-disclaimer-content"
        hidden={!isDisclaimerOpen}
      >
      <SebiInvestorAwareness />
      <p>
        <b>Standard disclaimer:</b>  Mutual fund investments are subject to market risks and past returns are not a guarantee of future
        returns.
      </p>
      <p>
        <b>Our take on disclaimer:</b> Yes, investing is a risky subject and you may also lose money. But each one of us is losing more
        money by not participating in markets. Key to good investing is asset allocation, discipline and avoiding bad apples. After
        that, volatility or ups and downs is the second nature of the market. Sticking to your asset allocation and avoiding that animal
        called greed is the best way to ensure that your money grows and grows well.
      </p>
      <span>
      WealthyIN Customer Services Private Limited
      </span>
      <p>
      AMFI registered Mutual Fund Distributor (ARN-106846) <br />
      Initial Registration : 20/11/2015 <br />
      ARN Valid Till : 20-Nov-2027
      </p>
      <p>
        For SAI/SID/KIM of funds refer:&nbsp;
        <SafeLink
          href="https://www.sebi.gov.in/filings/mutual-funds.html"
          style={{fontSize: "1.3rem", textDecoration: "underline", color: "blue"}}
        >Mutual Fund Filings</SafeLink>
      </p>
      <span>
        Buildwealth Technologies Private Limited
      </span>
      <p>
        IRDAI Corporate Insurance Agent - CA0711
      </p>

      <p>
        WealthyIN Broking Private Limited
      </p>
      <p>
        <b>Website Details: </b>
        <SafeLink
          className="anchor-footer"
          href="https://www1.nseindia.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          NSE
        </SafeLink>/
        <SafeLink
          className="anchor-footer"
          href="https://www.bseindia.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          BSE
        </SafeLink>/
        <SafeLink
          className="anchor-footer"
          href="https://www.sebi.gov.in/index.html"
          rel="noopener noreferrer"
          target="_blank"
        >
          SEBI
        </SafeLink>/
        <SafeLink
          className="anchor-footer"
          href="https://www.cdslindia.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          CDSL
        </SafeLink>/
        <SafeLink
          className="anchor-footer"
          href="https://scores.gov.in/scores/Welcome.html"
          rel="noopener noreferrer"
          target="_blank"
        >
          SCORES
        </SafeLink>/
        <SafeLink
          className="anchor-footer"
          href=" https://www.amfiindia.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          AMFI
        </SafeLink>
        <br />

        <br />Disclaimer: Investment in securities market are subject to market risks, read all the related documents carefully before investing
        WealthyIN Broking Private Limited, Registered Office: 3rd Floor, Block B, No. 55/10, Harlukunte Village Sector 2 HSR Layout, Bengaluru - 560 102, Karnataka, India
        Phone: +080- 48520671 website: www.wealthy.in
        For partner queries:<b  style={{fontSize: "13.5px"}}>partner.support@wealthy.in</b>&nbsp;
        For investor queries: <b  style={{fontSize: "13.5px"}}>customer.support@wealthy.in</b>, for grievances: <b>wbgrievance@wealthy.in </b>&nbsp;
        Compliance Officer (Stock Broker & DP): Mr. ANOOP P R Email: <b>compliance@wealthy.in</b>,
        For DP related to <b>customer.support@wealthy.in</b>, please ensure you carefully read the Risk Disclosure Document as prescribed by SEBI&nbsp;
        <u>Corporate Identity Number</u>: U67110KA2022PTC159371, <u>SEBI Stock Broker Registration No</u>: INZ000308532, <u>Depository Participant</u>: IN-DP- 737-2022 Member: NSE TM ID 90293, BSE TM ID 6798, <u>RA License - SEBI Reg No</u>: INH000012175, <u>BSE Enlistment No</u>: 5767.
      </p>

      <p><b>Attention Investors</b></p>
      <p>
        1. Submission of nomination details/declaration for opting out of nomination for investors is mandatory for all individual Trading and Demat accounts. If you have not submitted your choice of nomination, please provide the same on or before 30th September 2023, failing which the trading account shall be frozen for trading and demat account shall be frozen for debits.
      </p>
      <p>
        2. Linking PAN with Aadhaar is mandatory !. To avoid restrictions in operating your demat & trading account, please link your PAN with Aadhaar.
      </p>
      <p>
        3. KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (broker, DP, Mutual Fund etc.), you need not undergo the same process again when you approach another intermediary.
      </p>
      <p>
        4. Prevent Unauthorised transactions in your account -- Update your mobile numbers/email IDs with your stock brokers. Receive information of your transactions directly from Exchange on your mobile/email at the end of the day .......... Issued in the interest of investors
      </p>
      <p>
        5. ASBA - No need to issue cheques by investors while subscribing to IPO. Just write the bank account number and sign in
        the application form to authorise your bank to make payment in case of allotment. No worries for refund as the money
        remains in investor's account.
      </p>
      <p>
        6. We would like to bring to your attention that unauthorised / illegal SMSs maybe sent in the name of WealthyIN, recommending certain scripts. We advise you to exercise caution and verify its authenticity before you act on a recommendation received via SMS or email.All SMSs/ email recommendations for the day that are sent by WealthyIN, can be verified by visiting our trading site.
      </p>
      <p>
        7. Message from Exchanges and Depositories : The mentioned 6 KYC attributes ( Name, Address, PAN, valid Mobile number , valid Email id & Income Range) shall be mandatory in a client profile w.e.f August 1’st 2021 for newly registered clients and September 30,2021 for existing clients. Accounts without the mentioned 6 KYC attributes shall be considered as non-compliant accounts. Issued in the interest of investors.
      </p>
      <p>
        8. Investors are requested to note that Stockbroker M/s WealthyIN Broking Private Limited is permitted to receive/pay money from/to investors through designated bank accounts only named as client bank accounts. Stockbroker M/s WealthyIN Broking Private Limited is also required to disclose these client bank accounts to Stock Exchange. Hence, you are requested to use following client bank accounts only for the purpose of dealings in your trading account with us. The details of these client bank accounts are also displayed by Stock Exchanges on their website under “Know/ Locate your Stockbroker.
        <br />
        <SafeLink
          className="anchor-footer"
          href={`${WealthyEnv.BROKING_COMPLIANCE_CDN_URL}/bank-account-details-27-may-2026.pdf`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Bank Details
        </SafeLink>
      </p>
      <p>
        9. 1). Stock Brokers can accept securities as margin from clients only by way of pledge in the
depository system w.e.f. September 01, 2020. 2). Update your email id and mobile number with
your stock broker / depository participant and receive OTP directly from depository on your email id
and/or mobile number to create pledge. 3). Check your securities / MF / bonds in the consolidated
account statement issued by NSDL/CDSL every month........... Issued in the interest of Investors&quot;
      </p>

      <p><b>What is SCORES?</b></p>
      <p>
        <SafeLink
          className="anchor-footer"
          href="https://scores.sebi.gov.in/"
          rel="noopener noreferrer"
          target="_blank"
        >
          SCORES
        </SafeLink> is an online platform designed to help investors to lodge their complaints, pertaining to the securities market, online with SEBI against listed companies and SEBI registered intermediaries. All complaints received by SEBI against listed companies and SEBI registered intermediaries are dealt through SCORES.
        Filing complaints on SCORES – Easy & quick
        a. Register on SCORES portal
        b. Mandatory details for filing complaints on SCORES :
        i. Name, PAN, Address, Mobile Number, Email ID
        c. Benefits :
        i. Effective communication
        ii. Speedy redressal of the grievances
      </p>

      <p>
      Procedure for filing a complaint on a designated email id &amp; finding out status of the complaint etc.:-
The client has to send an email to <SafeLink className="anchor-footer" href="mailto:wbgrievance@wealthy.in">wbgrievance@wealthy.in</SafeLink> to register a complaint. The status of the
complaint will be provided to the client upon asking over the thread mail.
      </p>

      <SafeLink
        className="anchor-footer"
        href={`${url}/advisory-for-investors`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <b>Advisory for investors</b>
      </SafeLink><br /><br />


      <p><b>Segregation and Monitoring of Collateral at Client Level from NSE Clearing Ltd</b></p>
      <p>
        Measures have been implemented from NSE Clearing Ltd to create awareness among the clients. NSE Clearing has provided a web portal facility to allow clients to view their disaggregated collateral placed with Member and as reported by their registered Trading Member /Clearing Member. To access collateral details, NSE Clearing Ltd. (NCL) has made available a registration link and viewing facility on their website.<br />
        <SafeLink
          className="anchor-footer"
          href="https://investorhelpline.nseindia.com/ClientCollateral/welcomeCLUser"
          rel="noopener noreferrer"
          target="_blank"
        >
        To know more
        </SafeLink>

        <br />To see contract note&nbsp;
        <SafeLink
          aria-label="Open Wealthy partner backoffice to view contract note"
          className="anchor-footer"
          href="https://backoffice.wealthy.in/WebClient/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Wealthy Broking Back Office
        </SafeLink>
      </p>

      <br />
      <p>
      SMART ODR PLATFORM URL:
        <SafeLink
          className="anchor-footer"
          href="https://smartodr.in/login"
          rel="noopener noreferrer"
          target="_blank"
          >{" "}https://smartodr.in/login
        </SafeLink>
      </p>
      </div>

      <SafeLink
        className="anchor-footer"
        href="https://evoting.cdslindia.com/Evoting/EVotingLogin"
        rel="noopener noreferrer"
        target="_blank"
      >
        e-Voting facility for Shareholders
      </SafeLink>
      <p>
        <SafeLink
          className="anchor-footer"
          href={`${url}/sebi-awareness-programme`}
          rel="noopener noreferrer"
          style={{marginTop: "2rem"}}
          target="_blank"
        >
        SEBI Educational Programme
        </SafeLink>
      </p>
    </div>
    <div className="footer-copyright-container">

      <div className="footer-copyright">
        <p className="copyright-text">
          <span className="copyright-text-name">Buildwealth Technologies Pvt. Ltd.</span>  Copyright 2019, All Rights Reserved
        </p>

        <SafeLink
          className="copyright-text-links"
          href="/privacy"
          target="_blank"
        >
            &nbsp;Privacy Policy
        </SafeLink>

        <SafeLink
          className="copyright-text-links"
          href="/investor-charter"
          target="_blank"
        >
          &nbsp;Investor Charter
        </SafeLink>

        <SafeLink
          className="copyright-text-links"
          href="/investor-awareness"
          target="_blank"
        >
          &nbsp;Investor Awareness
        </SafeLink>
        <SafeLink
          className="copyright-text-links"
          href="https://drive.google.com/drive/folders/18VWXBgdbN6kx4B2gQAIO47EX-we5J-nq?usp=drive_link"
          target="_blank"
        >
          &nbsp;Policies & Procedures
        </SafeLink>
        <SafeLink
          className="copyright-text-links"
          href="/account-closure"
          target="_blank"
        >
          &nbsp;Account Closure
        </SafeLink>
      </div>
    </div>
  </footer>
  );
};

export default NewFooter;
